import { useRef } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SOCIALS, BRAND } from "../data/content";
import { SectionLabel, Reveal } from "./Reveal";
import BrandIcon from "./BrandIcons";

function ConnectCard({ s, index }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <motion.a
      ref={ref}
      href={s.href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseMove={onMove}
      data-testid={`connect-${s.icon}`}
      data-cursor
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.7, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
      className="group relative overflow-hidden glass rounded-sm p-6 md:p-7 flex items-center justify-between hover:border-white/30 transition-colors duration-500"
    >
      {/* cursor-follow illumination */}
      <span
        className="pointer-events-none absolute -inset-px opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: "radial-gradient(180px circle at var(--mx) var(--my), rgba(255,255,255,0.10), transparent 60%)" }}
      />
      {/* chrome sheen */}
      <span
        className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700"
        style={{ background: "linear-gradient(120deg, transparent 35%, rgba(255,255,255,0.08) 50%, transparent 65%)" }}
      />
      <div className="relative flex items-center gap-4">
        <span className="text-white/80 group-hover:text-white transition-colors duration-300">
          <BrandIcon name={s.icon} size={26} />
        </span>
        <span className="font-body text-base md:text-lg text-white/85 group-hover:text-white transition-colors">{s.label}</span>
      </div>
      <ArrowUpRight
        size={18}
        className="relative text-white/35 group-hover:text-white group-hover:rotate-45 transition-all duration-500"
      />
    </motion.a>
  );
}

export default function Connect() {
  return (
    <section id="connect" className="relative w-full py-24 md:py-36 px-5 md:px-10" data-testid="section-connect">
      <div className="max-w-[1100px] mx-auto">
        <SectionLabel index="07 / CONNECT" id="connect-label">SOCIAL</SectionLabel>
        <h2 className="font-display chrome-text text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-14 md:mb-20">
          <Reveal text={`CONNECT WITH ${BRAND.name}`} />
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {SOCIALS.map((s, i) => (
            <ConnectCard key={s.icon} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
